<template>
  <b-modal @hide="modalClose" ref="spaceListModal" :title="$t('置き場一覧')" size="lg">
    <b-container fluid>
      <div class="d-flex justify-content-end mb-4 mr-4">
        <button
          type="button"
          class="btn btn-success"
          @click="spaceRegisterModalOpen()"
        >{{ $t('新規登録') }}</button>
      </div>
      <div class="space-content border m-4 p-4 column">
        <h6 class="modal-table-title p-3 bg-light">{{ $t("置き場") }}</h6>
        <table class="table table-bordered">
          <thead class="thead-light thead">
            <tr>
              <th class="text-left">{{ $t("置き場名") }}</th>
              <th class="text-left">{{ $t("置き場コード") }}</th>
              <th class=""></th>
              <th class=""></th>
            </tr>
          </thead>
          <tbody v-if="!load">
            <tr v-for="(item, index) in list" :key="`space-${index}`">
              <td>{{ item.name }}</td>
              <td>{{ item.code }}</td>
              <td class="text-center">
                <button
                  type="button"
                  class="btn btn-light"
                  @click="spaceRegisterModalOpen(item)"
                >{{ $t('編集') }}</button>
              </td>
              <td class="text-center">
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteAlert(item)"
                >{{ $t('削除') }}</button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="999">
                <div class="d-flex justify-content-center my-5">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-container>
    <space-register-modal
      ref="spaceRegister"
      @space-init="init()"
    ></space-register-modal>
  </b-modal>
</template>

<script>
import spaceRegisterModal from './spaceRegisterModal'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      list: [],
      load: false,
      deleting: false,
    }
  },
  components: {
    spaceRegisterModal,
  },
  methods: {
    // モーダルを開いたときの処理
    async modalOpen() {
      this.$refs.spaceListModal.show()
      this.init()
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.$refs.spaceListModal.hide()
    },
    async init() {
      this.list = []
      this.load = true
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/spaces`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.list = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      this.load = false
    },
    // 置き場を登録するモーダルを開く処理
    spaceRegisterModalOpen(item = {}) {
      this.$refs.spaceRegister.modalOpen(item)
    },
    // 置き場の削除処理
    async deleteAlert(item) {
      const confirm = await this.$swal({
        text: `${item.name}` + this.$t('削除確認メッセージ'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: 'btn-danger',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        try {
          await this.$axios.put(
            `${this.$appConfig.CommonApiUrl}/space`,
            {id: item.id, isDelete: true},
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
            }
          )
          this.$swal.close()
          this.$toasted.success('データ削除完了メッセージ')
          this.init()
        } catch (err) {
          this.$toasted.show('データ削除エラーメッセージ')
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
#spaceListModal {
  .modal-dialog {
    max-width: 100rem;
  }
  .space-content {
    max-height: 60vh;
    overflow-y: scroll;
  }
}
.processKind {
  border: solid 2px #ddd;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
}
</style>
